// getters
const schoolRoutesMonitors = state => state.schoolRoutesMonitors

export default {
  schoolRoutesMonitors
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/monitors/getters.js